export default __webpack_public_path__ + "static/media/fb-big.1b182928.svg";